import { connect } from 'react-redux';
import Tour from '../components/Tour/Tour';
import { setMainPage, setShowTour, setTourStep } from '../actions/app';
import { openFileManager, closeFileManager } from '../actions/filemanager';
import { assembleSteps } from '../components/Tour/steps';

const mapStateToProps = (state) => {
  return {
    showTour: state.app.showTour,
    steps: assembleSteps({ gameMode: state.app.gameMode }),
    stepIndex: state.app.tourStep,
    appPage: state.app.page,
    fmOpen: state.filemanager.visible,
  };
};

const mapDispatchToProps = {
  setMainPage,
  openFileManager,
  closeFileManager,
  setShowTour,
  setTourStep,
};

export default connect(mapStateToProps, mapDispatchToProps)(Tour);
